import { Pipe, PipeTransform } from '@angular/core';

@Pipe({name: 'orderBy'})
export class OrderBy implements PipeTransform {
    transform(array: any[], getField: Function, reverse: boolean ): any[] {
        if (array && getField) {
            return array.sort((a: any, b: any) => {
              let x = 0;
              if (getField(a) < getField(b)) {x = -1; }
              if (getField(a) >= getField(b)) {x = 1; }
              if (reverse) {x *= -1; }
              return x;
            });
        } else {
            return array;
        }
    }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./~/tslint-loader!./src/app/shared/orderby.pipe.ts